import React, { useEffect, useRef, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import {
  collection,
  query,
  where,
  getDocs,
  orderBy,
  limit,
  addDoc,
  arrayUnion,
  arrayRemove,
} from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, storage } from "../firebase/firebase";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import background_image from "../img/take-notes.jpg";
import { async } from "@firebase/util";
import workoutImage from "../img/session_bg.png";
import profile from "../img/profile.png";

export default function EditUsers() {
  const [isLoading, setIsLoading] = useState(true);
  const [isRemoving, setIsRemoving] = useState(false);
  const [user, setUser] = useState([]);
  const navigate = useNavigate();
  const [plan, setPlan] = useState();
  const [refString, setRefString] = useState("");
  const [userRef, setUserRef] = useState(getUrlVars());
  const [planList, setPlanList] = useState(<></>);
  const [privateplansList, setPrivatePlansList] = useState();
  const [trainings, setTrainings] = useState();
  const [history, setHistory] = useState();
  const [refHeight, setRefHeight] = useState(0);
  const [isModalAddPlan, setIsModalAddPlan] = useState(false);
  const [isModalGroup, setIsModalGroup] = useState(false);
  const [groups, setGroups] = useState([]);
  const [activeGroups, setActiveGroups] = useState([]);
  const refObj = useRef(null);
  const [isActiveTrainer, setIsActiveTrainer] = useState(false);

  const [isSeen, setIsSeen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [permGroups, setPermGroups] = useState(null);

  const loadPermission = async (urlVar) => {
    var group;
    var admin = false;

    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    await querySnapshot.forEach((doc) => {
      if (doc.data().isAdmin == true) {
        setIsAdmin(true);
        admin = true;
      }

      setPermGroups(doc.data().permission_groups);
      group = doc?.data()?.group;
    });

    var q2 = query(collection(db, "permissions"));

    const querySnapshot2 = await getDocs(q2);

    await querySnapshot2.forEach((doc) => {
      setGroups(doc?.data()?.group);
    });

    loadUserData(group, admin);
  };

  const getUser = async () => {
    const auth = await getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        loadPermission(user.uid);
      } else {
        window.location.replace("/");
      }
    });
  };

  useEffect(() => {
    getUser();
  }, []);

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function timeout(delay) {
    return new Promise((res) => setTimeout(res, delay));
  }

  const updateHeight = async () => {
    if (refObj.current) {
      await timeout(500);
      setRefHeight(refObj?.current?.offsetHeight);
    }
  };

  const changeTrainerStatus = async () => {
    const refPlan = doc(db, "users", getParameterByName("userid"));

    await updateDoc(refPlan, {
      isTrainer: !isActiveTrainer,
    });

    setIsActiveTrainer(!isActiveTrainer);
  };

  function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);

    if (!results) return null;
    if (!results[2]) return "";
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  function getUrlVars() {
    return getParameterByName("userid");
  }

  const RenderPlan = () => {
    return (
      <a
        className="flex-row"
        href={refString}
        style={{
          maxWidth: 600,
          backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${background_image})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <i style={{ color: "#fff" }} className="fa-solid fa-check">
          <FontAwesomeIcon icon={icon({ name: "check", style: "solid" })} />
        </i>
        <div className="right">
          <h3 style={{ color: "#fff" }}>{plan?.name_de}</h3>
          <p style={{ color: "#fff" }}>{plan?.desc_de}</p>
        </div>
      </a>
    );
  };

  const RenderTrainings = () => {
    const elements = [<></>];

    try {
      if (trainings != undefined) {
        trainings?.map((obj, index) => {
          if (index < 3)
            elements.push(
              <>
                <a
                  className="flex-row"
                  href={refString}
                  style={{
                    backgroundImage: `linear-gradient(to bottom, rgba(33,37,43,0.90), rgba(33,37,43,0.90)), url(${workoutImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                >
                  <i style={{ color: "#fff" }} className="fa-solid fa-check">
                    <FontAwesomeIcon
                      icon={icon({ name: "check", style: "solid" })}
                    />
                  </i>
                  <div className="right">
                    <h3 style={{ color: "#fff", margin: 0 }}>{obj?.name}</h3>
                    <p style={{ color: "#fff" }}>{obj?.desc}</p>
                    <p style={{ color: "#fff" }}>
                      {new Date(obj?.date.toDate())
                        .toLocaleString()
                        .slice(0, -3) + " Uhr"}
                    </p>
                  </div>
                </a>
              </>
            );
        });
      }
    } catch (error) {}

    return <>{elements}</>;
  };

  const RenderHistory = () => {
    const elements = [<></>];

    try {
      if (history != undefined) {
        history?.map((obj, index) => {
          if (index < 3)
            elements.push(
              <>
                <a
                  className="flex-row"
                  href={refString}
                  style={{
                    backgroundImage: `linear-gradient(to bottom, rgba(33,37,43,0.90), rgba(33,37,43,0.90)), url(${workoutImage})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                  }}
                >
                  <i style={{ color: "#fff" }} className="fa-solid fa-check">
                    <FontAwesomeIcon
                      icon={icon({ name: "clock", style: "regular" })}
                    />
                  </i>
                  <div className="right">
                    <h3 style={{ color: "#fff", margin: 0 }}>{obj?.name}</h3>
                    <p style={{ color: "#fff", marginBottom: 10 }}>
                      {new Date(obj?.timestamp.toDate())
                        .toLocaleString()
                        .slice(0, -3) + " Uhr"}
                    </p>
                    <p style={{ color: "#fff", marginBottom: 0 }}>
                      {"Dauer: " +
                        (obj?.duration / 60000).toFixed(0) +
                        " Minuten"}
                    </p>
                    <p style={{ color: "#fff", marginBottom: 0 }}>
                      {"Bewertung: " + obj?.motivation + "/5"}
                    </p>
                    <p style={{ color: "#fff", marginBottom: 0 }}>
                      {"Intensität: " + obj?.intensity + "/5"}
                    </p>
                    {/* <p style={{ color: "#fff", marginBottom: 10 }}>
                      {"Kalorien verbrennt: " + obj?.kcal}
                    </p> */}
                    <p style={{ color: "#fff", marginBottom: 0 }}>
                      {"Anmerkung: " + (obj?.notes ? obj?.notes : "-")}
                    </p>
                  </div>
                </a>
              </>
            );
        });

        if (history?.length == 0) {
          elements.push(
            <>
              <h3 style={{ margin: 0, fontSize: 20, color: "#7a3260" }}>
                {"Keine vergangenen Einheiten."}
              </h3>
            </>
          );
        }
      }
    } catch (error) {}

    return <>{elements}</>;
  };

  const Content = () => (
    <section className="home-section">
      <div className="text">
        User Übersicht
        <a
          href="createplan"
          style={{
            color: "white",
            marginTop: 50,
            marginLeft: 15,
          }}
          className="fa-solid fa-plus"
        ></a>
      </div>

      {/* plans */}
      <section
        style={{ paddingTop: 50, paddingBottom: 40 }}
        className="my-plans"
        id="plans"
      >
        <div className="container">
          {isLoading ? (
            <h1 style={{ margin: 0, fontSize: 30 }}>{"Laden..."}</h1>
          ) : (
            <RenderUser></RenderUser>
          )}
        </div>
      </section>

      <section style={{ paddingTop: 0 }} className="my-plans" id="plans">
        <div className="container">
          <h2 style={{ marginBottom: "20px", textAlign: "left" }}>
            Aktiver Plan
          </h2>
          {plan ? (
            <>
              <RenderPlan></RenderPlan>
              <h2
                style={{
                  marginBottom: "20px",
                  marginTop: 20,
                  textAlign: "left",
                }}
              >
                Kommende Einheiten
              </h2>
              <div style={{}} className="grid plan-list" id="plan-list">
                <RenderTrainings></RenderTrainings>
              </div>
              <div
                style={{ marginTop: 20 }}
                className="grid plan-list"
                id="plan-list"
              >
                <a
                  // href="createplan"
                  onClick={() => {
                    alert("todo pagination");
                  }}
                >
                  {/* <div className="flex-row">
                    <i
                      style={{ color: "#7a3260" }}
                      className="fa-solid fa-plus"
                    >
                      <FontAwesomeIcon
                        icon={icon({ name: "ellipsis", style: "solid" })}
                      />
                    </i>
                    <div className="right">
                      <h3 style={{ margin: 0 }}>Mehr</h3>
                    </div>
                  </div> */}
                </a>
              </div>
            </>
          ) : (
            <>
              <h3 style={{ margin: 0, fontSize: 20, color: "#7a3260" }}>
                {"Kein aktiver Plan."}
              </h3>
            </>
          )}
          <h2
            style={{
              marginBottom: "0px",
              textAlign: "left",
              marginTop: "30px",
            }}
          >
            Freigegebene Pläne
          </h2>
          {planList ? (
            <div style={{}} className="grid plan-list" id="plan-list">
              {planList}
            </div>
          ) : (
            <></>
          )}
          <div
            style={{ marginTop: 20 }}
            className="grid plan-list"
            id="plan-list"
          >
            <a>
              <div
                className="flex-row"
                onClick={() => {
                  setIsModalAddPlan(true);
                }}
              >
                <i style={{ color: "#7a3260" }} className="fa-solid fa-plus">
                  <FontAwesomeIcon
                    icon={icon({ name: "plus", style: "solid" })}
                  />
                </i>
                <div className="right">
                  <h3 style={{ margin: 0 }}>Trainingsplan freigeben</h3>
                </div>
              </div>
            </a>
          </div>
          <h2
            style={{
              marginBottom: "20px",
              textAlign: "left",
              marginTop: "30px",
            }}
          >
            Trainings Verlauf
          </h2>
          <div
            style={{ paddingBottom: 20 }}
            className="grid plan-list"
            id="plan-list"
          >
            <RenderHistory></RenderHistory>
          </div>

          {isAdmin ? (
            <>
              <h2
                style={{
                  marginBottom: "20px",
                  textAlign: "left",
                  marginTop: "30px",
                }}
              >
                Trainer Gruppe
              </h2>

              <a
                style={{ cursor: "pointer", marginTop: 20 }}
                onClick={() => {
                  changeTrainerStatus();
                }}
              >
                <div className="list-container">
                  <div
                    style={{
                      backgroundColor: "#fff",
                      borderBottom: "1px solid hsl(210, 14%, 83%)",
                      paddingTop: 10,
                      paddingBottom: 10,
                    }}
                    className="list-item"
                  >
                    <p
                      style={{
                        padding: 2,
                        border: "1px solid hsl(210, 14%, 83%)",
                        marginRight: 15,
                        marginLeft: 10,
                        backgroundColor: "#fff",
                      }}
                    >
                      <FontAwesomeIcon
                        style={{
                          color: isActiveTrainer ? "#21252b" : "transparent",
                        }}
                        icon={icon({ name: "check", style: "solid" })}
                      />
                    </p>
                    <p style={{ color: "#000", fontSize: 14 }}>
                      {"User ist ein Trainer"}
                    </p>
                  </div>
                </div>
              </a>

              {isActiveTrainer && (
                <div style={{ marginTop: 20 }}>
                  <p
                    style={{
                      color: "#000",
                      fontSize: 14,
                      fontWeight: "bold",
                      marginBottom: 20,
                    }}
                  >
                    {"Aktive Gruppen:"}
                  </p>
                  {activeGroups?.map((obj) => (
                    <a>
                      <div className="list-container">
                        <div
                          style={{
                            backgroundColor: "#fff",
                            borderBottom: "1px solid hsl(210, 14%, 83%)",
                            paddingTop: 10,
                            paddingBottom: 10,
                          }}
                          className="list-item"
                        >
                          <a
                            style={{
                              paddingLeft: 15,
                              paddingRight: 15,
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              removeGroup(obj);
                            }}
                          >
                            <FontAwesomeIcon
                              style={{
                                color: "red",
                              }}
                              icon={icon({
                                name: "trash-can",
                                style: "regular",
                              })}
                            />
                          </a>
                          <p style={{ color: "#000", fontSize: 14 }}>{obj}</p>
                        </div>
                      </div>
                    </a>
                  ))}
                </div>
              )}

              {isActiveTrainer && (
                <div
                  style={{ marginTop: 20 }}
                  className="grid plan-list"
                  id="plan-list"
                >
                  <a>
                    <div
                      className="flex-row"
                      onClick={() => {
                        setIsModalGroup(true);
                      }}
                    >
                      <i
                        style={{ color: "#7a3260" }}
                        className="fa-solid fa-plus"
                      >
                        <FontAwesomeIcon
                          icon={icon({ name: "plus", style: "solid" })}
                        />
                      </i>
                      <div className="right">
                        <h3 style={{ margin: 0 }}>
                          Berechtigungs-Gruppe hinzufügen
                        </h3>
                      </div>
                    </div>
                  </a>
                </div>
              )}
            </>
          ) : (
            <></>
          )}

          <div style={{ height: 40 }}></div>

          <div style={{ display: "flex" }}>
            {/* <button
              onClick={() => {}}
              className="btn submit-form"
              type="submit"
            >
              Speichern
            </button> */}
            {/* <div style={{ width: 10 }}></div> */}

            <button
              onClick={() => navigate(-1)}
              className="btn btn-gray submit-form"
              type="submit"
            >
              Abbrechen
            </button>
            <div style={{ width: 10 }}></div>
          </div>

          <div style={{ width: 10 }}></div>
        </div>
      </section>
    </section>
  );

  var userdat;

  const loadUserData = async (permGroup, admin) => {
    var userDocId = "";

    try {
      const q = query(
        collection(db, "users"),
        where("__name__", "==", getUrlVars())
      );

      const querySnapshot = await getDocs(q);

      var help = [];

      querySnapshot.forEach((doc) => {
        userDocId = doc.id;
        help.push(doc);
      });

      var userdata = help[0]?.data();

      userdat = userdata;
      setUser(userdata);
      setIsActiveTrainer(userdata?.isTrainer);
      setActiveGroups(userdata?.permission_groups);
    } catch (error) {}

    try {
      var q;
      if (admin) {
        q = query(collection(db, "plans"));
      } else {
        q = query(
          collection(db, "plans"),
          where("permission_groups", "array-contains-any", permGroup)
        );
      }

      const querySnapshot = await getDocs(q);

      var help = [];

      querySnapshot.forEach((doc) => {
        if (doc?.data().isActive) {
        } else {
          if (!userdat.privatePlans) {
            var data = doc.data();
            data.id = doc.id;
            help.push(data);
          } else if (userdat.privatePlans.indexOf(doc.id) == -1) {
            var data = doc.data();
            data.id = doc.id;
            help.push(data);
          }
        }
      });

      setPrivatePlansList(help);
    } catch (error) {
      alert("Err1 " + error);
    }

    try {
      const q2 = query(
        collection(db, "plans"),
        where("__name__", "==", userdata?.activePlanId)
      );

      const querySnapshot2 = await getDocs(q2);

      querySnapshot2.forEach((doc) => {
        setRefString("editplan?planid=" + doc.id);
        setPlan(doc?.data());
      });
    } catch (error) {}

    try {
      var help = [];

      const q2 = query(
        collection(db, "users", userDocId, "trainings"),
        orderBy("date"),
        limit(3)
        //startAfter(lastVisible),
      );

      const querySnapshot2 = await getDocs(q2);

      querySnapshot2.forEach((doc) => {
        help.push(doc.data());
      });

      setTrainings(help);
    } catch (error) {
      alert("error");
      alert(JSON.stringify(error));
    }

    try {
      var help = [];

      const q2 = query(
        collection(db, "users", userDocId, "history"),
        orderBy("timestamp", "desc"),
        limit(3)
        //startAfter(lastVisible),
      );

      const querySnapshot2 = await getDocs(q2);

      querySnapshot2.forEach((doc) => {
        help.push(doc.data());
      });

      setHistory(help);
    } catch (error) {
      alert("error");
      alert(JSON.stringify(error));
    }

    try {
      const q3 = query(
        collection(db, "plans")
        // where("__name__", "==", userdata?.activePlanId)
      );

      const querySnapshot3 = await getDocs(q3);

      const elements = [<></>];

      querySnapshot3.forEach((doc, index) => {
        var refString = "editplan?planid=" + doc.id;

        if (userdat.privatePlans)
          if (userdat.privatePlans.indexOf(doc.id) > -1)
            elements.push(
              <a
                className="flex-row"
                // href={refString}
                style={{
                  backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${background_image})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "cover",
                  marginBottom: 10,
                }}
              >
                <FontAwesomeIcon
                  onClick={() => {
                    removePlan(doc.id);
                  }}
                  style={{
                    backgroundColor: "#7a3260",
                    padding: 5,
                    borderRadius: 999,
                    width: "20px",
                    height: "20px",
                    color: "#fff",
                    position: "absolute",
                    zIndex: 9999,
                    cursor: "pointer",
                    top: 10,
                    right: 10,
                  }}
                  icon={icon({ name: "close", style: "solid" })}
                />
                <FontAwesomeIcon
                  // href={refString}
                  onClick={() => {
                    window.location.href = refString;
                  }}
                  style={{
                    backgroundColor: "#7a3260",
                    padding: 7.5,
                    borderRadius: 999,
                    width: "15px",
                    height: "15px",
                    color: "#fff",
                    position: "absolute",
                    zIndex: 9999,
                    cursor: "pointer",
                    top: 10,
                    right: 50,
                  }}
                  icon={icon({ name: "edit", style: "solid" })}
                />
                <i style={{ color: "#fff" }} className="fa-solid fa-check">
                  <FontAwesomeIcon
                    icon={icon({ name: "check", style: "solid" })}
                  />
                </i>
                <div className="right">
                  <h3 style={{ color: "#fff", paddingTop: 20 }}>
                    {doc.data().name_de}
                  </h3>
                </div>
              </a>
            );
      });

      setPlanList(<div style={{ paddingTop: 20 }}>{elements}</div>);
    } catch (error) {
      alert("Err2 " + error);
    }

    setIsLoading(false);
  };

  const selPage = "users";

  const onSeen = async () => {
    const refPlan = doc(db, "users", getParameterByName("userid"));

    var newRequest = user.request;
    newRequest.isNew = false;

    await updateDoc(refPlan, {
      request: newRequest,
    });

    setIsSeen(true);
  };

  function RenderUser() {
    return (
      <>
        <ul style={{ alignItems: "center", display: "flex" }}>
          <li>
            {user.photoUrl ? (
              <img
                style={{
                  width: 100,
                  height: 100,
                  marginRight: 20,
                  borderRadius: 90,
                  objectFit: "cover",
                }}
                src={user.photoUrl}
                alt=""
              ></img>
            ) : (
              <img
                style={{
                  width: 100,
                  height: 100,
                  marginRight: 20,
                }}
                src={profile}
                alt=""
              ></img>
            )}
          </li>
          <li>
            <h1 style={{ margin: 0, fontSize: 30 }}>
              {user?.username}
              {user?.request?.isNew == false ?? (
                <i
                  style={{ color: "#21252b", marginLeft: 5 }}
                  className="fa-solid fa-check"
                >
                  <FontAwesomeIcon
                    style={{ width: 25, height: 25, marginBottom: 4 }}
                    icon={icon({ name: "message", style: "regular" })}
                  />
                </i>
              )}
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: 20,
                color: "#7a3260",
                marginBottom: 10,
              }}
            >
              {"" +
                (user?.level == 0
                  ? "Anfänger"
                  : user?.level == 1
                  ? "Fortgeschritten"
                  : "Profi")}
            </p>
          </li>
        </ul>

        <div style={{ height: 10 }}></div>

        <p style={{ margin: 0, fontSize: 20, color: "#000" }}>
          {user?.mail ? "E-Mail: " + user?.mail : ""}
        </p>

        <p style={{ fontSize: 20, margin: 0 }}>
          {"Geschlecht: " + user?.gender}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"Geburtsdatum: "}
          {new Date(user?.birthday.toDate()).toLocaleString().split(",")[0]}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"Gewicht: " + user?.weight + " kg"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"Größe: " + user?.height + " cm"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"HFmax: " + user?.maxHR + " bpm"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"Recom: " +
            (user?.recomFrom == undefined
              ? (Number(user?.maxHR) * 0.5).toFixed(0)
              : user?.recomFrom) +
            "-" +
            (user?.recomTo == undefined
              ? (Number(user?.maxHR) * 0.6).toFixed(0)
              : user?.recomTo) +
            " bpm"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"GA1: " +
            (user?.ga1From == undefined
              ? (Number(user?.maxHR) * 0.6).toFixed(0)
              : user?.ga1From) +
            "-" +
            (user?.ga1To == undefined
              ? (Number(user?.maxHR) * 0.7).toFixed(0)
              : user?.ga1To) +
            " bpm"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"GA2: " +
            (user?.ga2From == undefined
              ? (Number(user?.maxHR) * 0.7).toFixed(0)
              : user?.ga2From) +
            "-" +
            (user?.ga2To == undefined
              ? (Number(user?.maxHR) * 0.8).toFixed(0)
              : user?.ga2To) +
            " bpm"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"EB: " +
            (user?.ebFrom == undefined
              ? (Number(user?.maxHR) * 0.8).toFixed(0)
              : user?.ebFrom) +
            "-" +
            (user?.ebTo == undefined
              ? (Number(user?.maxHR) * 0.9).toFixed(0)
              : user?.ebTo) +
            " bpm"}
        </p>
        <p style={{ fontSize: 20, margin: 0 }}>
          {"SB: " +
            (user?.sbFrom == undefined
              ? (Number(user?.maxHR) * 0.9).toFixed(0)
              : user?.sbFrom) +
            "-" +
            (user?.sbTo == undefined
              ? (Number(user?.maxHR) * 1).toFixed(0)
              : user?.sbTo) +
            " bpm"}
        </p>

        {user?.request ? (
          <a
            className="flex-row"
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(33,37,43,1), rgba(0,0,0,1)), url(${workoutImage})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              cursor: "default",
              marginTop: 30,
            }}
          >
            <i style={{ color: "#fff" }} className="fa-solid fa-check">
              <FontAwesomeIcon
                icon={icon({ name: "message", style: "regular" })}
              />
            </i>
            <div className="right">
              {user?.request?.isNew == true && isSeen == false ? (
                <h3 style={{ fontSize: 20, color: "#FF0000", margin: 0 }}>
                  {"Neue Anfrage"}
                </h3>
              ) : (
                <h3 style={{ fontSize: 20, color: "#FF0000", margin: 0 }}>
                  {"Anfrage"}
                </h3>
              )}
              <div
                style={{
                  fontSize: 18,
                  color: "#fff",
                  marginTop: 10,
                  marginBottom: 10,
                  whiteSpace: "pre-wrap",
                }}
              >
                {user?.request?.note}
              </div>

              <p style={{ fontSize: 18, margin: 0, color: "white" }}>
                {"Muskelaufbau: " + user?.request?.muscleBuilding + "/5"}
              </p>
              <p style={{ fontSize: 18, margin: 0, color: "white" }}>
                {"Ausdauer: " + user?.request?.endurance + "/5"}
              </p>
              <p style={{ fontSize: 18, margin: 0, color: "white" }}>
                {"Gesundheit: " + user?.request?.health + "/5"}
              </p>
              <p style={{ fontSize: 18, margin: 0, color: "white" }}>
                {"Abnehmen: " + user?.request?.loseWeight + "/5"}
              </p>

              {user?.request?.isNew == true && isSeen == false && (
                <button
                  style={{ marginTop: 18 }}
                  onClick={() => onSeen()}
                  className="btn btn-gray submit-form"
                  type="submit"
                >
                  Gelesen
                </button>
              )}
            </div>
          </a>
        ) : (
          <></>
        )}
      </>
    );
  }

  function addSelPlan(plan) {
    onSelPlan(plan);
  }

  function addSelGroup(group) {
    onSelGroup(group);
  }

  const onSelGroup = async (group) => {
    try {
      const plansDoc = doc(db, "users", userRef);

      await updateDoc(plansDoc, {
        permission_groups: arrayUnion(group),
      });
    } catch (error) {
      alert(error);
    }

    setIsLoading(false);
    loadUserData(permGroups, isAdmin);

    setIsModalAddPlan(false);
  };

  const onSelPlan = async (plan) => {
    try {
      const plansDoc = doc(db, "users", userRef);

      await updateDoc(plansDoc, {
        privatePlans: arrayUnion(plan.id),
      });
    } catch (error) {
      alert(error);
    }

    setIsLoading(false);

    loadUserData(permGroups, isAdmin);

    setIsModalAddPlan(false);
  };

  const removePlan = async (planid) => {
    try {
      const plansDoc = doc(db, "users", userRef);

      await updateDoc(plansDoc, {
        privatePlans: arrayRemove(planid),
      });
    } catch (error) {
      alert(error);
    }

    getUser();
  };

  const removeGroup = async (group) => {
    try {
      const plansDoc = doc(db, "users", userRef);

      await updateDoc(plansDoc, {
        permission_groups: arrayRemove(group),
      });
    } catch (error) {
      alert(error);
    }

    loadUserData(permGroups, isAdmin);
  };

  function ModelItems() {
    return (
      <>
        {groups.map((obj) => (
          <a
            style={{ cursor: "pointer" }}
            onClick={() => {
              addSelGroup(obj);
              setIsModalGroup(false);
            }}
            key={"groupitem" + 1}
          >
            <div key={1} className="list-container">
              <div style={{ backgroundColor: "#fff" }} className="list-item">
                <p style={{ color: "#000", paddingLeft: 10 }}>{obj}</p>
              </div>
            </div>
          </a>
        ))}
      </>
    );
  }

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>

      {/* Add plan Modal */}
      <div
        style={{
          zIndex: 999,
          display: isModalAddPlan ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg"}
      >
        <ul
          ref={refObj}
          className={
            "mobile-nav " + (isModalAddPlan ? "slide-in" : "slide-out")
          }
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <form className="contact-form workout-edit">
            <p style={{ color: "#fff", paddingBottom: 16, fontSize: 20 }}>
              {"Wähle einen Trainingsplan:"}
            </p>

            {privateplansList &&
              privateplansList.map((obj) => (
                <a
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    addSelPlan(obj);
                  }}
                  key={"planspicker" + 1}
                >
                  <div key={1} className="list-container">
                    <div
                      style={{ backgroundColor: "#fff" }}
                      className="list-item"
                    >
                      <p style={{ color: "#000", paddingLeft: 10 }}>
                        {obj?.name_de}
                      </p>
                    </div>
                  </div>
                </a>
              ))}

            <p></p>
          </form>
          <button
            onClick={() => {
              setIsModalAddPlan(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModalAddPlan(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2,
            width: windowDimensions.width - 600,
            minHeight: "100%",
            height: refHeight,
          }}
        ></div>
      </div>

      {/* Add Group Modal */}

      <div
        style={{
          zIndex: 999,
          display: isModalGroup ? "unset" : "none",
          overflowY: "auto",
        }}
        className={"mobile-bg "}
      >
        <ul
          ref={refObj}
          className={"mobile-nav " + (isModalGroup ? "slide-in" : "slide-out")}
          style={{
            backgroundColor: "#21252b",
            width: "50%",
            maxWidth: 600,
            minHeight: "100%",
            height: "auto",
          }}
        >
          <li>
            <a>Wähle eine Gruppe zum hinzufügen aus:</a>
          </li>
          {ModelItems()}
          {/* <button
            onClick={() => {
              // addWorkouts();
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 0, marginRight: 10 }}
          >
            Gruppen hinzufügen
          </button> */}
          <button
            onClick={() => {
              setIsModalGroup(false);
            }}
            className="btn submit-form"
            type="submit"
            style={{ marginTop: 20, marginBottom: 20 }}
          >
            Abbrechen
          </button>
        </ul>

        <div
          onClick={() => {
            setIsModalGroup(false);
          }}
          style={{
            backgroundColor: "transparent",
            minWidth: windowDimensions.width / 2,
            width: windowDimensions.width - 600,
            minHeight: "100%",
            height: refHeight,
          }}
        ></div>
      </div>

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
